var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { useState, useRef } from "react";
import { useCountDown } from "./useCountDown";
import { ImageCode } from "./ImageCode";
import * as data from "./data";
import { Toast } from "../Toast";
import * as style from "./LoginStyle";
import { inputBoxCommon, btnCommon } from "./indexStyle";
export function Login(props) {
    const [formValue, setFormValue] = useState({
        mobile: "",
        code: "",
        privacy: false
    });
    // 登录组件动画状态
    const [show, setShow] = useState(true);
    // 图形验证码组件状态
    const [imageCodeValue, setImageCodeValue] = useState({
        src: "",
        show: false
    });
    // 获取短信时图形验证码临时数据
    const smsICValue = useRef(null);
    // 登录时图形验证码临时数据
    const loginICValue = useRef(null);
    /**
     * 重新获取验证码时长
     */
    const CountDownTotal = 60;
    // 这里是倒计时相关逻辑
    const [runCountDown, setRunCountDown] = useState(false);
    const [cdTimeLeft, setCdTimeLeft] = useState(CountDownTotal);
    /**
     * 验证码倒计时逻辑
     */
    useCountDown(timeLeft => {
        setCdTimeLeft(timeLeft);
    }, () => {
        setRunCountDown(false);
        setCdTimeLeft(CountDownTotal);
    }, CountDownTotal, runCountDown);
    /**
     * 表单值更新
     * @param name
     * @param value
     */
    const changeValue = (name, value) => {
        setFormValue(Object.assign(Object.assign({}, formValue), { [name]: value }));
    };
    /**
     * 主动获取短信验证码逻辑
     */
    const getSmsCode = () => {
        // 1、验证手机号格式
        if (!/^1\d{10}$/.test(formValue.mobile)) {
            Toast.create({
                content: "手机号码格式错误",
                position: "bottom"
            });
            return;
        }
        // 图形验证码的临时存储信息
        let imageCodeInfo = {};
        if (smsICValue.current !== null) {
            imageCodeInfo = Object.assign({}, smsICValue.current);
        }
        (() => __awaiter(this, void 0, void 0, function* () {
            try {
                // 2、调用获取验证码接口
                const codeResult = yield data.getSmsCode(formValue.mobile, imageCodeInfo);
                if (codeResult.code === 1) {
                    // 成功获取短信验证码，倒计时开始
                    setRunCountDown(true);
                    // 清空图形验证码临时数据
                    smsICValue.current = null;
                }
                else if (codeResult.code === 15001) {
                    smsICValue.current = {
                        api_ticket: codeResult.data.api_ticket
                    };
                    // 显示图形验证码组件
                    setImageCodeValue({ src: codeResult.data.captcha_url, show: true });
                }
                else {
                    // 显示其他错误类型
                    Toast.create({
                        content: codeResult.msg,
                        position: "bottom"
                    });
                    // 清空图形验证码临时数据
                    smsICValue.current = null;
                }
            }
            catch (error) {
                Toast.create({
                    content: "网络异常，请重试",
                    position: "bottom"
                });
            }
        }))();
    };
    const login = () => {
        // 1、验证手机号格式
        if (!/^1\d{10}$/.test(formValue.mobile)) {
            Toast.create({
                content: "手机号码格式错误",
                position: "bottom"
            });
            return;
        }
        // 2、短信验证码格式错误
        if (!/^\d{6}$/.test(formValue.code)) {
            Toast.create({
                content: "短信验证码格式错误",
                position: "bottom"
            });
            return;
        }
        // 3、是否同意隐私协议
        if (!formValue.privacy) {
            Toast.create({
                content: "请确认并同意《车轮平台隐私政策》",
                position: "bottom"
            });
            return;
        }
        (() => __awaiter(this, void 0, void 0, function* () {
            // 图形验证码的临时存储信息
            let imageCodeInfo = {};
            if (loginICValue.current !== null) {
                imageCodeInfo = Object.assign({}, loginICValue.current);
            }
            // 调用登录API
            const loginResult = yield data.loginWithSmsCode(formValue.mobile, formValue.code, imageCodeInfo);
            if (loginResult.code === 1) {
                // 登录成功，清空图形验证码临时数据
                loginICValue.current = null;
                // 执行成功回调
                typeof props.onLogin === "function" &&
                    props.onLogin(Object.assign({ mobile: formValue.mobile, code: formValue.code }, loginResult.data));
            }
            else if (loginResult.code === 15001) {
                loginICValue.current = {
                    api_ticket: loginResult.data.api_ticket
                };
                // 显示图形验证码组件
                setImageCodeValue({ src: loginResult.data.captcha_url, show: true });
            }
            else {
                Toast.create({
                    content: loginResult.msg,
                    position: "bottom"
                });
                // 清除图形验证码数据
                loginICValue.current = null;
            }
        }))();
    };
    return (jsx("div", { css: style.loginStyle, className: show ? "show" : "hide", onAnimationEnd: event => {
            if (event.animationName === style.LoginHide.name) {
                typeof props.onEnd === "function" && props.onEnd();
            }
        } },
        jsx("div", { css: style.logoStyle },
            jsx("h3", null, "\u767B\u5F55\u8F66\u8F6E"),
            jsx("p", null, "\u4E00\u7AD9\u5F0F\u8F66\u751F\u6D3B\u4EA4\u6613\u670D\u52A1\u5E73\u53F0")),
        jsx("div", { css: [inputBoxCommon, style.inputBoxStyle] },
            jsx("input", { type: "text", maxLength: 11, value: formValue.mobile, placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801", onChange: event => changeValue("mobile", event.target.value) })),
        jsx("div", { css: [inputBoxCommon, style.inputBoxStyle] },
            jsx("input", { type: "text", maxLength: 6, value: formValue.code, placeholder: "\u8BF7\u8F93\u5165\u77ED\u4FE1\u9A8C\u8BC1\u7801", onChange: event => changeValue("code", event.target.value) }),
            !runCountDown ? (jsx("div", { className: "code", onClick: () => {
                    // 首先清空验证码
                    setFormValue(Object.assign(Object.assign({}, formValue), { code: "" }));
                    // 其次获取验证码
                    getSmsCode();
                } }, "\u83B7\u53D6\u9A8C\u8BC1\u7801")) : (jsx("div", { className: "code disable" },
                cdTimeLeft,
                "\u79D2"))),
        jsx("div", { css: style.privacyStyle, className: formValue.privacy ? "active" : undefined },
            jsx("div", { onClick: () => {
                    setFormValue(Object.assign(Object.assign({}, formValue), { privacy: !formValue.privacy }));
                } },
                jsx("svg", { viewBox: "0 0 24 24" }, formValue.privacy ? (jsx("path", { d: "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })) : (jsx("path", { d: "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" }))),
                "\u8BF7\u786E\u8BA4\u5E76\u540C\u610F",
                jsx("a", { href: "https://m.chelun.com/2019/chelun-protocol/index.html#/privacy/1", onClick: e => {
                        e.stopPropagation();
                    } }, "\u300A\u8F66\u8F6E\u5E73\u53F0\u9690\u79C1\u653F\u7B56\u300B"))),
        jsx("div", { css: [btnCommon, style.btnStyle] },
            jsx("div", { className: "cancel", onClick: () => {
                    setShow(false);
                    typeof props.onCancel === "function" && props.onCancel();
                } }, "\u53D6\u6D88\u767B\u5F55"),
            jsx("div", { className: "confirm", onClick: login }, "\u786E\u8BA4\u767B\u5F55")),
        imageCodeValue.show ? (jsx(ImageCode, { initSrc: imageCodeValue.src, onConfirm: code => {
                setImageCodeValue({ src: "", show: false });
                if (smsICValue.current !== null) {
                    smsICValue.current.verify_code = code;
                    (() => __awaiter(this, void 0, void 0, function* () {
                        // 获取ImageCode的值
                        const imgCookie = yield data.getImageCodeCookie();
                        smsICValue.current.image_code = imgCookie.data.ImageCode;
                        // 再次调用获取短信验证码
                        getSmsCode();
                    }))();
                }
                else if (loginICValue.current !== null) {
                    loginICValue.current.verify_code = code;
                    (() => __awaiter(this, void 0, void 0, function* () {
                        // 获取ImageCode的值
                        const imgCookie = yield data.getImageCodeCookie();
                        loginICValue.current.image_code = imgCookie.data.ImageCode;
                        // 再次调用登录逻辑
                        login();
                    }))();
                }
            }, onCancel: () => {
                setImageCodeValue({ src: "", show: false });
                // 清空图形验证码临时数据
                smsICValue.current = null;
                loginICValue.current = null;
            } })) : null));
}
